<template>
    <input :ref="this.id" :type="type()"
        :class="[{ 'has': value && base.Util().validate(String(value)) }, { 'safe': meta.type === 'password' }]"
        v-model="value" :readonly="readonly" :disabled="disabled" :autocomplete="meta.type === 'password'
            ? 'new-password'
            : 'off'" @focus="focus(true)" @blur="focus(false)" @keydown="keypress">
    <i v-if="this.meta.type === 'password' && vm" :class="[{ 'fe-eye': !toggle }, { 'fe-eye-off': toggle }]"
        class="vscenter toggle fe fe-16" @click="toggle = !toggle && !disabled"></i>
    <DatePicker v-show="!disabled" v-if="meta.type === 'date'" :id="`vpd-${this.id}`" v-model="value">
    </DatePicker>
</template>

<script>
/* eslint-disable */
import DatePicker from 'vue3-persian-datetime-picker'

import cities from '../../../assets/data/cities.json'

require('../../../assets/js/amount')

export default {
    name: 'TextBox',
    props: ['meta', 'vm', 'active', 'disabled'],
    inject: ['base'],
    components: { DatePicker },
    computed: {
        key() {
            return this.meta.key
        },
        typeof() {
            return this.meta.type
        },
        env() {
            return this.$cookies.get(String(this.max).replace('env(', '')
                .replace(')', ''))
        }
    },
    created() {
        this.init()
    },
    data() {
        return {
            id: '',
            minlen: Number(this.base.Entities().parse(this.meta.extras)['minlen'] || '0'),
            maxlen: Number(this.base.Entities().parse(this.meta.extras)['maxlen'] || 1.7976931348623157e+308),
            length: 0,
            min: this.base.Entities().parse(this.meta.extras)['min'] || 0,
            max: this.base.Entities().parse(this.meta.extras)['max'] || 1.7976931348623157e+308,
            value: this.vm || '',
            hint: '',
            error: false,
            readonly: false,
            isNumeric: ['mobile', 'tel', 'date', 'amount'
                , 'number', 'iban', 'nid', 'card'].includes(this.meta.type),
            toggle: false,
            format: ''
        }
    },
    watch: {
        key() {
            if (this.base.Entities().parse(this.meta.extras)['focus'] === 'YES') {
                this.id = this.base.Util().hash(4)
                setTimeout(() => {
                    this.$refs[this.id].focus()
                }, 100)
            }
        },
        typeof(newTypeOf, oldTypeOf) {
            this.init()
        },
        vm(newVM, oldVM) {
            if (this.value !== this.vm) {
                this.value = this.vm
                this.hint = ''
            }
        },
        env(newEnv, oldEnv) {
            if (typeof (this.max) === 'string' && this.max.includes('env'))
                this.max = this.$cookies.get(String(this.max).replace('env(', '')
                    .replace(')', '')) || '0'
        },
        disabled(newDisabled, oldDisabled) {
            this.toggle = !this.disabled
        },
        length(newLength, oldLength) {
            this.length = this.base.Util().validate(this.length) ? this.length : 2147483646
        },
        value(newValue, oldValue) {
            this.handle()

            if (this.isNumeric) {
                if (this.meta.type === 'iban')
                    this.value = `IR${String(this.value).replace(/[^0-9]/g, '')}`
                else if (this.meta.type === 'date')
                    this.value = String(this.value).replace(/[^0-9]/g, '')
                        .replace(/(\d{4})(\d{2})(\d{2})/, '$1/$2/$3')
                else if (this.meta.type === 'amount')
                    this.value = String(this.value).replace(/[^0-9]/g, '').replace(/\s/g, '').replace(/,/g, '')
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                else if (this.meta.type === 'number')
                    this.value = String(this.value)
                        .replace(/[^0-9.]/g, '')
                        .replace(/^(\.)/, '')
                        .replace(/(\..*)\./g, '$1')
                else
                    this.value = String(this.value).replace(/[^0-9]/g, '')
            }

            this.$emit('onchange', {
                value: String(this.value),
                hint: this.hint,
                error: this.error
            })
        },
        hint(newHint, oldHint) {
            this.$emit('onchange', {
                value: String(this.value),
                hint: this.hint,
                error: this.error
            })
        }
    },
    methods: {
        init() {
            this.length = (this.meta.type === 'mobile' || this.meta.type === 'tel' || this.meta.type === 'nid')
                ? 12
                : this.meta.type === 'iban'
                    ? 26
                    : this.meta.type === 'date'
                        ? 10
                        : this.meta.type === 'card'
                            ? 19
                            : this.base.Entities().parse(this.meta.extras)['length']

            if (this.vm)
                this.handle()

            this.hint = this.base.Entities().parse(this.meta.extras)['hint'] || ''

            if (this.meta.type === 'date' || this.base.Entities().parse(this.meta.extras)['focus'] === 'YES') {
                this.id = this.base.Util().hash(4)
                if (this.meta.type === 'date')
                    this.readonly = true
            }

            if (this.base.Entities().parse(this.meta.extras)['focus'] === 'YES')
                setTimeout(() => this.$refs[this.id].focus(), 100)

            if (typeof (this.max) === 'string' && this.max.includes('env'))
                this.max = this.$cookies.get(String(this.max).replace('env(', '')
                    .replace(')', '')) || '0'

            this.isNumeric = ['mobile', 'tel', 'date', 'amount'
                , 'number', 'iban', 'nid', 'card', 'series'].includes(this.meta.type)
        },
        type() {
            return (this.meta.type === 'mobile' || this.meta.type === 'tel')
                ? 'tel' : (this.meta.type === 'date' || this.meta.type === 'amount') || (this.meta.type === 'password' && this.toggle) || this.meta.type === 'uniqueidentifier' || this.meta.type === 'nid' || this.meta.type === 'series'
                    ? 'text'
                    : this.meta.type
        },
        handle() {
            if (this.meta.type !== 'detection')
                this.reformat()
            switch (this.meta.type) {
                case 'text':
                    this.text()
                    break
                case 'detection':
                    this.detection()
                    break
                case 'email':
                    this.email()
                    break
                case 'mobile':
                    this.mobile()
                    break
                case 'tel':
                    this.tel()
                    break
                case 'date':
                    this.date()
                    break
                case 'amount':
                    this.amount()
                    break
                case 'password':
                    this.password()
                    break
                case 'number':
                    this.number()
                    break
                case 'iban':
                    this.iban()
                    break
                case 'nid':
                    this.nid()
                    break
                case 'card':
                    this.card()
                    break
                default:
                    if (this.type() === 'text')
                        this.text()
                    break
            }
        },
        text() {
            const length = String(this.value).length >= this.minlen
                && String(this.value).length <= this.maxlen
            switch (this.base.Entities().parse(this.meta.extras)['locale'] || 'DEFAULT') {
                case 'fa-IR':
                    this.error = !length || (this.value !== '' && (!/^[\u0600-\u06FF\s]+$/.test(this.value)
                        || /^(.)\1{2,}$/.test(this.value)))
                    break
                default:
                    this.error = !length
                    break
            }
        },
        detection() {
            if (this.value != '') {
                if (/^e472[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(this.value)) {
                    this.error = false
                    this.hint = 'شناسه یکتا'
                    return
                }

                this.format = 'mobile'
                let value = this.reformat(false)
                this.mobile(value)
                if (!this.error) {
                    this.value = value
                    this.hint = 'شماره همراه'
                    return
                }

                this.nid()
                if (!this.error)
                    return

                if (this.value.length > 12) {
                    this.format = 'card'
                    value = this.reformat(false)
                    this.card(value)
                    if (!this.error) {
                        this.value = value
                        this.hint = `شماره کارت - ${this.hint}`
                        return
                    }
                }

                if (this.value.length >= 24) {
                    this.format = 'iban'
                    value = this.reformat(false)
                    this.iban(value)
                    if (!this.error) {
                        this.value = value
                        this.hint = `شماره شبا - ${this.hint}`
                        return
                    }
                }

                this.error = true
                this.hint = ''
            } else {
                this.error = false
                this.hint = ''
            }
        },
        email() {
            this.error = this.value !== ''
            if (this.value.includes('@')) {
                let email = this.value.split('@')
                if (email[1].includes('.'))
                    this.error = !this.base.Util().validate(email[1].split('.')[1])
            }
        },
        mobile(value = '') {
            this.error = (value || this.value) !== '' && !(
                (['98900', '98901', '98902', '98903', '98904', '98905'
                    , '98910', '98911', '98912', '98913', '98914', '98915', '98916'
                    , '98917', '98918', '98919', '98990', '98991', '98992', '98993'
                    , '98994', '98996', '98930', '98933', '98935', '98936', '98937'
                    , '98938', '98939', '98941', '98920', '98921', '98922', '98923', '98998'
                    , '98999'].includes(String((value || this.value || '')).slice(0, 5))) && (value || this.value).length === 12)
        },
        tel(value = '') {
            this.error = (value || this.value) !== '' && !(
                (['9841', '9844', '9845', '9831', '9826', '9884', '9877', '9821', '9838'
                    , '9856', '9851', '9858', '9861', '9824', '9823', '9854', '9871', '9828', '9825', '9874'
                    , '9887', '9834', '9883', '9817', '9813', '9866', '9811', '9886', '9876', '9881', '9835']
                    .includes(String((value || this.value || '')).slice(0, 4))) && (value || this.value).length === 12)
        },
        date() {
            let year = 0
            let month = 0
            let day = 0

            let value = String(this.value).split('/')
            if (value.length === 3) {
                year = Number(value[0])
                month = Number(value[1])
                day = Number(value[2])
            }

            if (String(this.value).length === 13)
                this.error = false
            else
                this.error = this.value !== '' && !((year >= 1300 && year <= 1500) && ((month <= 6 && month >= 1 && day <= 31)
                    || (month <= 12 && month >= 7 && day <= 30)) && day >= 1
                    && ((month < 12) || (month === 12 && day < 30)
                        || (month === 12 && day === 30 && ['1435', '1431', '1427', '1423', '1419', '1415', '1411', '1407', '1403'
                            , '1399', '1395', '1391', '1387', '1383', '1379', '1375', '1370', '1366', '1362'
                            , '1358', '1354', '1350', '1346', '1342', '1337', '1333', '1329', '1325', '1321'
                            , '1317', '1313', '1309', '1300'].includes(value[0]))))
        },
        amount() {
            this.error = this.value !== '' && !(this.min <= Number(this.value.replace(/\s/g, '').replace(/,/g, ''))
                && this.max >= Number(this.value.replace(/\s/g, '').replace(/,/g, ''))
                && String(Math.round(Number(String(this.value).replace(/\s/g, '').replace(/,/g, '')) / 1000) * 1000) === this.value.replace(/\s/g, '').replace(/,/g, ''))
        },
        password() {
            if (this.base.Entities().parse(this.meta.extras)['complexity'])
                this.error = this.value !== '' && !(/^(?=.*[0-9])(?=.*[!@#$%^&*~_-])[a-zA-Z0-9!@#$%^&*~_-]{8,24}$/)
                    .test(this.value)
        },
        number() {
            this.error = this.value !== '' && !(this.min <= Number(this.value)
                && this.max >= Number(this.value))
        },
        iban(value = '') {
            let prefix = (value || this.value).slice(4, 7)
            switch (prefix) {
                case '012':
                    this.hint = 'ملت'
                    break
                case '017':
                    this.hint = 'ملی'
                    break
                case '019':
                    this.hint = 'صادرات'
                    break
                case '015':
                    this.hint = 'سپه'
                    break
                case '018':
                    this.hint = 'تجارت'
                    break
                case '016':
                    this.hint = 'کشاورزی'
                    break
                case '014':
                    this.hint = 'مسکن'
                    break
                case '021':
                    this.hint = 'پست بانک'
                    break
                case '020':
                    this.hint = 'توسعه صادرات'
                    break
                case '057':
                    this.hint = 'پاسارگاد'
                    break
                case '054':
                    this.hint = 'پارسیان'
                    break
                case '055':
                    this.hint = 'اقتصاد نوین'
                    break
                case '013':
                    this.hint = 'رفاه'
                    break
                case '061':
                    this.hint = 'شهر'
                    break
                case '022':
                case '051':
                    this.hint = 'توسعه تعاون'
                    break
                case '062':
                    this.hint = 'آینده'
                    break
                case '058':
                    this.hint = 'سرمایه'
                    break
                case '056':
                    this.hint = 'سامان'
                    break
                case '059':
                    this.hint = 'سینا'
                    break
                case '011':
                    this.hint = 'صنعت و معدن'
                    break
                case '053':
                    this.hint = 'کار آفرین'
                    break
                case '052':
                    this.hint = 'قوامین'
                    break
                case '060':
                    this.hint = 'قرض الحسنه مهر'
                    break
                case '063':
                    this.hint = 'انصار'
                    break
                case '064':
                    this.hint = 'گردشگری'
                    break
                case '065':
                    this.hint = 'حکمت ایرانیان'
                    break
                case '066':
                    this.hint = 'دی'
                    break
                case '069':
                    this.hint = 'ایران زمین'
                    break
                case '070':
                    this.hint = 'قرض الحسنه رسالت'
                    break
                case '075':
                    this.hint = 'موسسه اعتباری ملل'
                    break
                case '079':
                    this.hint = 'مهر اقتصاد'
                    break
                case '078':
                case '080':
                    this.hint = 'خاورمیانه'
                    break
                default:
                    this.hint = ''
                    break
            }

            this.error = (value || this.value) !== '' && !((value || this.value).length === 26
                && this.base.Util().validate(this.hint))
        },
        card(value = '') {
            let prefix = (value || this.value).slice(0, 7)
            switch (prefix) {
                case '6367-95':
                    this.hint = 'مرکزی'
                    break
                case '6037-99':
                    this.hint = 'ملی'
                    break
                case '6104-33':
                    this.hint = 'ملت'
                    break
                case '9919-75':
                    this.hint = 'ملت'
                    break
                case '6280-23':
                    this.hint = 'مسکن'
                    break
                case '6037-69':
                    this.hint = 'صادرات'
                    break
                case '6276-48':
                    this.hint = 'توسعه صادرات'
                    break
                case '2071-77':
                    this.hint = 'توسعه صادرات'
                    break
                case '5892-10':
                    this.hint = 'سپه'
                    break
                case '6273-53':
                    this.hint = 'تجارت'
                    break
                case '6037-70':
                    this.hint = 'کشاورزی'
                    break
                case '6392-17':
                    this.hint = 'کشاورزی'
                    break
                case '5894-63':
                    this.hint = 'رفاه کارگران'
                    break
                case '6362-14':
                    this.hint = 'آینده'
                    break
                case '6219-86':
                    this.hint = 'سامان'
                    break
                case '6396-07':
                    this.hint = 'سرمایه'
                    break
                case '6393-46':
                    this.hint = 'سینا'
                    break
                case '5054-16':
                    this.hint = 'گردشگری'
                    break
                case '5029-38':
                    this.hint = 'دی'
                    break
                case '5028-06':
                    this.hint = 'شهر'
                    break
                case '6279-61':
                    this.hint = 'صنعت و معدن'
                    break
                case '5057-85':
                    this.hint = 'ایران زمین'
                    break
                case '6393-47':
                    this.hint = 'پاسارگاد'
                    break
                case '5022-29':
                    this.hint = 'پاسارگاد'
                    break
                case '6221-06':
                    this.hint = 'پارسیان'
                    break
                case '6391-94':
                    this.hint = 'پارسیان'
                    break
                case '6278-84':
                    this.hint = 'پارسیان'
                    break
                case '6274-12':
                    this.hint = 'اقتصاد نوین'
                    break
                case '6395-99':
                    this.hint = 'قوامین'
                    break
                case '6273-81':
                    this.hint = 'انصار'
                    break
                case '6277-60':
                    this.hint = 'پست بانک ایران'
                    break
                case '5029-08':
                    this.hint = 'توسعه تعاون'
                    break
                case '5041-72':
                    this.hint = 'رسالت'
                    break
                case '6274-88':
                    this.hint = 'کارآفرین'
                    break
                case '5029-10':
                    this.hint = 'کارآفرین'
                    break
                case '6393-70':
                    this.hint = 'مهر اقتصاد'
                    break
                case '6369-49':
                    this.hint = 'حمکت ایرانیان'
                    break
                case '6063-73':
                    this.hint = 'موسسه قرض الحسنه مهر ایران'
                    break
                case '6281-57':
                    this.hint = 'موسسه اعتباری توسعه'
                    break
                case '5058-01':
                    this.hint = 'موسسه اعتباری کوثر'
                    break
                case '5058-09':
                    this.hint = 'خاورمیانه'
                    break
                default:
                    break
            }

            this.error = (value || this.value) !== '' && !((value || this.value).length === 19
                && this.base.Util().validate(this.hint))
        },
        nid() {
            let valid = false
            let type = ''
            if (!(this.value === '' || isNaN(this.value))) {
                if (this.value.length === 10) {
                    const city = cities[this.value.slice(0, 3)]
                    if (/^\d{10}$/.test(this.value)) {
                        const allDigitEqual = [
                            "0000000000", "1111111111", "2222222222",
                            "3333333333", "4444444444", "5555555555",
                            "6666666666", "7777777777", "8888888888",
                            "9999999999"
                        ]

                        if (!allDigitEqual.includes(this.value)) {
                            const chArray = this.value.split('').map(Number)
                            const checksum = chArray[9]
                            let sum = 0

                            for (let i = 0; i < 9; i++)
                                sum += chArray[i] * (10 - i)

                            const remainder = sum % 11

                            valid = (remainder < 2 && checksum === remainder) ||
                                (remainder >= 2 && checksum === (11 - remainder))

                            if (valid) {
                                type = `کد ملی حقیقی `
                                if (city)
                                    type += `(${city})`
                            }
                        }
                    }
                } else if (this.value.length === 11) {
                    if (/^\d+$/.test(this.value)) {
                        const controlDigit = parseInt(this.value.charAt(10), 10)
                        const nationalCodeWithoutControlDigit = this.value.substring(0, 10)

                        const multipliers = [29, 27, 23, 19, 17, 29, 27, 23, 19, 17]
                        const decimalAdjustment = parseInt(this.value.charAt(9), 10) + 2

                        let sum = 0
                        for (let i = 0; i < 10; i++) {
                            const digit = parseInt(nationalCodeWithoutControlDigit.charAt(i), 10)
                            sum += (digit + decimalAdjustment) * multipliers[i]
                        }

                        const remainder = sum % 11;
                        const calculatedControlDigit = remainder === 10
                            ? 0
                            : remainder

                        valid = controlDigit === calculatedControlDigit

                        if (valid)
                            type = 'شناسه ملی حقوقی'
                    }
                } else if (this.value.length === 12) {
                    type = 'کد فیدا اتباع'
                    valid = true
                } else
                    type = ''
            } else
                type = ''

            this.hint = type
            this.error = this.value !== '' && !(valid && (this.base.Util().validate(this.hint)))
        },
        reformat(apply = true) {
            this.value = this.base.Util().locale(this.value)
            let value = this.value
            switch (this.format || this.meta.type) {
                case 'mobile':
                case 'tel':
                    if (String(this.value || '').length >= 2)
                        if (!this.value.startsWith('98'))
                            value = `98${this.value.slice(this.value.startsWith('0') ? 1 : 0
                                , this.value.length)}`
                        else if (this.value.startsWith('980'))
                            value = `98${this.value.slice(3, this.value.length)}`
                    break
                case 'date':
                    this.hint = this.base.Entities().parse(this.meta.extras)['hint'] || ''
                    value = String(this.value).replaceAll('/', '')
                    if (String(this.value).length === 13)
                        this.hint = String(this.base.Util().time({ unix: String(value), time: true }))
                    else
                        value = String(this.value).replace(/(\d{4})(\d{2})(\d{2})/, '$1/$2/$3')
                    break
                case 'amount':
                    value = String(this.value).replace(/\s/g, '').replace(/,/g, '')
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                    this.hint = this.value === '' || String(this.value).startsWith('0') ? ''
                        : String(this.value).replace(/\s/g, '').replace(/,/g, '').num2persian() + ' ریال'
                    break
                case 'iban':
                    if (this.value.length >= 2 && !this.value.startsWith('IR'))
                        value = `IR${this.value}`
                    break
                case 'card':
                    value = String(this.value).replaceAll('-', '')
                        .replace(/(\d{4})(\d{4})(\d{4})(\d{4})/, '$1-$2-$3-$4')
                    break
                default:
                    break
            }

            if (apply)
                this.value = value
            else
                return value
        },
        focus(status) {
            if (status && this.meta.type === 'date' && !this.disabled)
                document?.getElementById(`vpd-${this.id}`)?.getElementsByTagName('label')[0]?.click()

            if (status === false && this.value !== '')
                if ((this.meta.type === 'number' || this.meta.type === 'amount')) {
                    let value = Number(String(this.value).replace(/\s/g, '').replace(/,/g, ''))
                    if (this.min > value || this.max < value)
                        if (this.meta.type === 'number') {
                            if (this.min > value)
                                this.hint = `حداقل مقدار ${this.min} است`
                            else if (this.max < value)
                                this.hint = `حداکثر مقدار ${this.max} است`
                        } else if (this.meta.type === 'amount') {
                            if (this.min > value)
                                this.hint = `حداقل مقدار ${String(this.min).replace(/\s/g, '').replace(/,/g, '')
                                    .replace(/\B(?=(\d{3})+(?!\d))/g, ',')} ریال است`
                            else if (this.max < value)
                                this.hint = `حداکثر مقدار ${String(this.max).replace(/\s/g, '').replace(/,/g, '')
                                    .replace(/\B(?=(\d{3})+(?!\d))/g, ',')} ریال است`
                        }


                    if (this.meta.type === 'amount'
                        && String(Math.round(Number(String(this.value).replace(/\s/g, '').replace(/,/g, '')) / 1000) * 1000) !== this.value.replace(/\s/g, '').replace(/,/g, ''))
                        this.hint = `مبلغ می‌بایست ضریبی از 1000 ریال باشد`
                }
                else if (this.meta.type === 'date') {
                    if ((this.min < 0) && this.max) {
                        let min = typeof (this.min) === 'string'
                            ? Number(this.base.Util().time({ params: this.min }))
                            : this.min
                        let max = typeof (this.max) === 'string'
                            ? Number(this.base.Util().time({ params: this.max }))
                            : this.max
                        this.value = min > Number(this.base.Util().time({ date: this.value }))
                            ? this.base.Util().locale(this.base.Util().time({ unix: min }))
                            : max < Number(this.base.Util().time({ date: this.value }))
                                ? this.base.Util().locale(this.base.Util().time({ unix: max }))
                                : this.value
                        if (this.base.Entities().parse(this.meta.extras)['exception'] === 'holidays')
                            while (this.base.Util().time({ holiday: this.value, thursday: true }))
                                this.value = this.base.Util().locale(this.base.Util().time({
                                    unix: Number(this.base.Util().time({ date: this.value }))
                                        + 86400000
                                }))
                    }
                } else if (this.meta.type === 'text' || this.type() === 'text') {
                    if (!(String(this.value).length >= this.minlen))
                        this.hint = `حداقل طول ${this.minlen} کاراکتر است`
                    else if (!(String(this.value).length <= this.maxlen))
                        this.hint = `حداکثر طول ${this.maxlen} کاراکتر است`
                    else if (this.minlen > 0 || this.maxlen < 1.7976931348623157e+308)
                        this.hint = ''
                }
            this.$emit('onfocus', status)
        },
        keypress(event) {
            const allowedKeys = ['Control', 'A', 'C', 'V', 'X', 'ش', 'ط', 'ز', 'ر']
            if (event.ctrlKey && allowedKeys.includes(event.key.toUpperCase()))
                return

            let key = event.keyCode
            let length = (String(event.target.value).length >= this.length
                && event.target.selectionStart === event.target.selectionEnd) || !event.key.trim()
            let number = isNaN(this.base.Util().locale(event.key))
            let space = key === 32
            let general = (key !== 8 && key !== 9 && key !== 46 && key !== 116)
                && !(key === 37 || key === 38 || key === 39 || key === 40)
            if (general) {
                if (this.isNumeric) {
                    if (length || number || space) {
                        if (this.meta.type === 'number' && key === 190)
                            return
                        event.preventDefault()
                        event.stopImmediatePropagation()
                        return
                    }
                } else if (length && !space) {
                    event.preventDefault()
                    event.stopImmediatePropagation()
                    return
                }
            }
        }
    }
}
</script>